export const adminAppStatusFilterOrder = [
  'draft',
  'testing',
  'pending_publish',
  'active',
  'banned',
] as const
